import IconNavRight from '../../../../assets/svg/IconNavRight';
import { useOrientation } from '../../../../boot/OrientationContext';
import { neutralDark } from '../../../../constants/color';
import { GET_LAYOUT_MAX_WIDTH } from '../../../../constants/layout';
import Touchable from '../../../../elements/Touchable';
import { translate } from '../../../../i18n';
import { navigate } from '../../../../utils/navigationService';
import routeUtils from '../../../../utils/routes';
import styles, { S } from '../styles';

interface Props {
  isFetching: boolean;
  isTopSalesEmpty: boolean;
}

export default ({ isFetching, isTopSalesEmpty }: Props) => {
  useOrientation();

  const onPressMoreTopSales = () => {
    navigate('TopSalesListPage');
  };

  if (isTopSalesEmpty) return null;

  return (
    <S.TitleSection width={GET_LAYOUT_MAX_WIDTH()} testID="TopSalesTitle">
      <S.TitleText>{translate('top-sales')}</S.TitleText>
      {!isFetching && (
        <Touchable
          accessibilityRole="link"
          href={routeUtils.compileToPath('TopSalesListPage')}
          style={styles.moreTopSales}
          onPress={onPressMoreTopSales}
          hitSlop={{ top: 10, right: 10, bottom: 10, left: 10 }}
          testID="WatchMoreLink"
        >
          <S.MoreTopSalesText>{translate('watch-more')}</S.MoreTopSalesText>
          <IconNavRight size={14} fillColor={neutralDark} />
        </Touchable>
      )}
    </S.TitleSection>
  );
};
